import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Button, Spinner, Text, MessageBar, MessageBarBody } from '@fluentui/react-components';
import { Shell } from '@/components/Shell';
import { useAuth } from '@/hooks/useAuth';
import { Login } from '@/views/Login';
import { api, ApiError } from '@/lib/api';
import { StatusBadge } from '@/components/StatusBadge';
import { openUrl } from '@/lib/office';
import { APP_URL } from '@/lib/constants';
export function DocumentStatus() {
    const { authenticated } = useAuth();
    if (!authenticated)
        return _jsx(Login, { message: "Sign in to track documents you've sent." });
    return _jsx(List, {});
}
function List() {
    const [docs, setDocs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const load = async () => {
        setLoading(true);
        try {
            const res = await api.listDocuments();
            setDocs(res.documents);
            setError(null);
        }
        catch (e) {
            setError(e instanceof ApiError ? e.message : 'Couldn\'t load documents.');
        }
        finally {
            setLoading(false);
        }
    };
    useEffect(() => { void load(); }, []);
    return (_jsxs(Shell, { title: "Your documents", subtitle: "Latest 50 documents \u2014 newest first.", children: [error && (_jsx(MessageBar, { intent: "error", style: { marginBottom: 10 }, children: _jsx(MessageBarBody, { children: error }) })), loading ? (_jsx(Spinner, { size: "small", label: "Loading\u2026" })) : docs.length === 0 ? (_jsxs(Text, { size: 200, style: { color: '#605e5c' }, children: ["Nothing here yet. Send your first document from the ", _jsx("strong", { children: "Send for Signing" }), " button on the ribbon."] })) : (_jsxs("div", { style: { display: 'flex', flexDirection: 'column', gap: 6 }, children: [docs.map((d) => (_jsxs("div", { style: {
                            background: 'white', border: '1px solid #edebe9', borderRadius: 8,
                            padding: 10, display: 'flex', flexDirection: 'column', gap: 4,
                        }, children: [_jsxs("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }, children: [_jsx(Text, { size: 300, weight: "semibold", truncate: true, style: { minWidth: 0 }, children: d.title }), _jsx(StatusBadge, { status: d.status })] }), _jsxs(Text, { size: 100, style: { color: '#8a8886' }, children: [d.page_count, " pages \u00B7 updated ", new Date(d.updated_at ?? d.created_at).toLocaleDateString('en-GB')] }), _jsxs("div", { style: { display: 'flex', gap: 6, marginTop: 4 }, children: [_jsx(Button, { size: "small", appearance: "outline", onClick: () => openUrl(`${APP_URL}/documents/${d.id}/${d.status === 'draft' ? 'edit' : 'view'}`), children: "Open in Bleinks \u2197" }), d.status === 'draft' && (_jsx(Button, { size: "small", onClick: () => openUrl(`${APP_URL}/documents/${d.id}/edit`), children: "Continue editing" }))] })] }, d.id))), _jsx(Button, { size: "small", appearance: "subtle", onClick: () => void load(), style: { marginTop: 6 }, children: "Refresh" })] }))] }));
}
